import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAutocompleteDataLoader } from 'src/app/components/autocomplete/abstract-autocomplete-data-loader';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { ReturnUserDefinedStatus } from 'src/app/models/shared/return-user-defined-status';
import { RecommendationService } from '../recommendation/recommendation.service';

@Injectable({
  providedIn: 'root'
})
export class RecommendationUserDefinedStatusesAutocompleteDataLoaderService extends AbstractAutocompleteDataLoader {

  constructor(private recommendationService: RecommendationService) {super();}

  load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ search: searchTerm };
    return this.recommendationService.autocompleteUserDefinedStatuses(postFilterFields)
      .pipe(
        map(response => this.transformResponse(response))
      );
  }

  loadAll(): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ searchAll: true };
    return this.recommendationService.autocompleteUserDefinedStatuses(postFilterFields)
      .pipe(
        map(response => this.transformResponse(response))
      );
  }

  transformResponse(response: ReturnMessage<ReturnUserDefinedStatus[]>): ReturnMessage<AutocompleteOption[]> {
    let newReturnMessage = <ReturnMessage<AutocompleteOption[]>>{
      success: response.success,
      message: response.message,
      title: response.title,
      options: response.options,
      returncode: response.returncode
    };

    if (response.success) {
      newReturnMessage.payload = <AutocompleteOption[]>[];

      for (const status of response.payload) {
        newReturnMessage.payload.push({ id: status.id, description: status.description, sourceObject: status });
      }
    }

    return newReturnMessage;
  }
}
